import type { ReactNode } from 'react';
import { classNames } from 'primereact/utils';
import type { SettingDefinition } from './types';

type SettingRowProps = {
  setting: SettingDefinition;
  /** Ties the rendered `<label>` to the control's own input id (WCAG 1.3.1 / 4.1.2). */
  labelId: string;
  children: ReactNode;
};

/**
 * Label, description and control. The label is a `<div>`, not a heading — the control has its own `aria-labelledby`.
 */
export const SettingRow = ({ setting, labelId, children }: SettingRowProps) => {
  const isBlock = setting.layout === 'block';

  return (
    <div className={classNames('flex gap-4', isBlock ? 'flex-col' : 'items-start justify-between')}>
      <div className="flex min-w-0 flex-col gap-1">
        <div id={labelId} className="text-theme-black text-sm font-semibold">
          {setting.title}
        </div>
        {setting.description && <div className="text-theme-text-grey text-sm">{setting.description}</div>}
      </div>
      <div className={classNames(isBlock ? 'min-w-0' : 'flex shrink-0 items-center pt-0.5')}>{children}</div>
    </div>
  );
};
